import { HttpStatusCode } from '../types/http-status-code';
const parsableStatusCodes = new Set([
    HttpStatusCode.OK,
    HttpStatusCode.PartialContent,
    HttpStatusCode.MultiStatus
]);
export const isResponseParsable = (response) => parsableStatusCodes.has(response.status);
//# sourceMappingURL=is-response-parsable.js.map